import React from 'react'
import {connect} from 'react-redux'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import moment from 'moment'
import {PriorityHigh} from '@mui/icons-material'
import Tooltip from '@mui/material/Tooltip'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Dialog from 'components/Dialog'
import {fetchStatistics, resetStatistics} from 'modules/statistics/actions'
import {feedbackStatus} from 'utils/helpers'

const colors = {
    Awaiting: '#ffc300',
    Error: '#d45b4a',
    Delivered: '#4cae4c',
    Opened: '#4cae4c',
    Unsubscribed: '#d45b4a'
}

const Warning = styled(PriorityHigh)`
    font-size: 18px;
`

const Container = styled.div`
    display: flex;
    width: ${props => props.width}px;
    align-items: center;
    justify-content: center;
    height: 100%;
`

const Bulb = styled.div`
    height: 16px;
    width: 16px;
    display: inline-block;
    border-radius: 50%;
    background: radial-gradient(#cadce0, #eaf1f3);
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
`

const Awaiting = styled(Bulb)`
    box-shadow: 0 0 3px 0 #ffe799, 0 0 6px 3px #ffc300;
    cursor: pointer;
    background: radial-gradient(#ffc300, #ffcf33);
`

const Delivered = styled(Bulb)`
    box-shadow: 0 0 3px 0 #b5deb5, 0 0 6px 3px #4cae4c;
    cursor: pointer;
    background: radial-gradient(#4cae4c, #6ebf6e);
`

const Error = styled(Bulb)`
    box-shadow: 0 0 3px 0 #f1cbc6, 0 0 6px 3px #d45b4a;
    cursor: pointer;
    background: radial-gradient(#d45b4a, #de8073);
`

const Title = styled.div`
    display: flex;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 20px;
    align-items: center;
`

const Date = styled.div`
    font-weight: bold;
    font-size: 16px;
`

const Status = styled.div`
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 2px;
    font-weight: 700;
    display: flex;
    align-items: center;
    margin-left: 30px;
    color: ${props => props.color};

    div:first-child {
        cursor: default;
        margin-right: 15px;
    }
`

const ListDate = styled.div`
    color: #95a8ae;
    font-weight: bold;
    margin-right: 20px;
    white-space: nowrap;
`

const List = styled.div`
    display: flex;
    margin-bottom: 20px;
`

const Info = styled.div`
    div:first-child {
        font-weight: bold;
    }

    div:last-child {
        margin-top: 10px
    }
`

class Feedback extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            open: false
        }
    }

    handleOpen = () => {
        this.props.fetchStatistics(this.props.feedback.items)

        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.props.resetStatistics()

        this.setState({
            open: false
        })
    }

    render() {
        const {intl, feedback} = this.props

        return (
            <React.Fragment>
                <Container width={global.TABLE_STATUS_WIDTH} onClick={feedback ? this.handleOpen : undefined}>
                    {feedback && feedback.groups.length === 1 &&
                        <Tooltip
                            placement="right"
                            title={intl.formatMessage({
                                id: `feedback.status_${feedbackStatus[feedback.groups[0].status].toLowerCase()}`}, {
                                count: feedback.groups[0].items.length
                            })}
                        >
                            {feedback.groups[0].status === feedbackStatus.Delivered || feedback.groups[0].status === feedbackStatus.Opened ?
                                <Delivered />
                                : feedback.groups[0].status === feedbackStatus.Error || feedback.groups[0].status === feedbackStatus.Unsubscribed ?
                                <Error />
                                :
                                <Awaiting />
                            }
                        </Tooltip>
                    }
                    {feedback && feedback.groups.length > 1 &&
                        <Tooltip
                            placement="right"
                            title={<div>
                                {feedback.groups.map((group, index) =>
                                    <React.Fragment key={index}>
                                        {intl.formatMessage({
                                            id: `feedback.count_status_${feedbackStatus[group.status].toLowerCase()}`}, {
                                            count: group.items.length
                                        })}
                                        <br />
                                    </React.Fragment>
                                )}
                            </div>}
                        >
                            {feedback.groups[0].status === feedbackStatus.Delivered || feedback.groups[0].status === feedbackStatus.Opened ?
                                <Delivered>
                                    <Warning />
                                </Delivered>
                                : feedback.groups[0].status === feedbackStatus.Error || feedback.groups[0].status === feedbackStatus.Unsubscribed ?
                                <Error>
                                    <Warning />
                                </Error>
                                :
                                <Awaiting>
                                    <Warning />
                                </Awaiting>
                            }
                        </Tooltip>
                    }
                    {!feedback &&
                        <Bulb />
                    }
                </Container>
                {this.state.open && !!this.props.details &&
                    <Dialog
                        fullWidth={true}
                        open={this.state.open}
                        onClose={this.handleClose}
                    >
                        <DialogTitle>
                            {intl.formatMessage({id: "feedback.feedback_details"})}
                        </DialogTitle>
                        <DialogContent>
                            {this.props.details && this.props.details.map(item =>
                                <div key={item.id}>
                                    <Title>
                                        <Date>
                                            {intl.formatMessage({id: "feedback.sent_on"})} {moment(item.date).format('DD.MM.YYYY hh:mm:ss')}
                                        </Date>
                                        <Status color={colors[feedbackStatus[item.feedback.status]]}>
                                            {item.feedback.status === feedbackStatus.Delivered || item.feedback.status === feedbackStatus.Opened ?
                                                <Delivered />
                                                : item.feedback.status === feedbackStatus.Error || item.feedback.status === feedbackStatus.Unsubscribed ?
                                                <Error />
                                                :
                                                <Awaiting />
                                            }
                                            <div>
                                                {intl.formatMessage({
                                                    id: `feedback.count_status_${feedbackStatus[item.feedback.status].toLowerCase()}`}, {
                                                    count: ''
                                                })}
                                            </div>
                                        </Status>
                                    </Title>
                                    {item.history.map((obj, index) =>
                                        <List key={index}>
                                            <ListDate>
                                                {moment(obj.date).format('DD.MM.YYYY hh:mm:ss')}
                                            </ListDate>
                                            <Info>
                                                <div>
                                                    {obj.action}
                                                </div>
                                                <div>
                                                    {obj.info}
                                                </div>
                                            </Info>
                                        </List>
                                    )}
                                </div>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                {intl.formatMessage({id: "app.confirm_close"})}
                            </Button>
                        </DialogActions>
                    </Dialog>
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({statistics}) => ({
    details: statistics.details
})

export default connect(mapStateToProps, {fetchStatistics, resetStatistics})(injectIntl(Feedback))
